// extracted by mini-css-extract-plugin
export default {"wrapper":"menuAddSearchListItem_wrapper__VbPmG","imageWrapper":"menuAddSearchListItem_imageWrapper__byFu+","addWrapper":"menuAddSearchListItem_addWrapper__KYoDp"};